var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThemeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3.29998C17.5168 3.29998 20.4101 4.53265 22.5433 6.72683C24.6766 8.921 25.875 11.8969 25.875 15C25.875 18.103 24.6766 21.0789 22.5433 23.2731C20.4101 25.4673 17.5168 26.7 14.5 26.7V3.29998ZM14.5 0.599976C10.787 0.599976 7.22601 2.11711 4.60051 4.81764C1.975 7.51816 0.5 11.1809 0.5 15C0.5 18.8191 1.975 22.4818 4.60051 25.1823C7.22601 27.8828 10.787 29.4 14.5 29.4C18.213 29.4 21.774 27.8828 24.3995 25.1823C27.025 22.4818 28.5 18.8191 28.5 15C28.5 11.1809 27.025 7.51816 24.3995 4.81764C21.774 2.11711 18.213 0.599976 14.5 0.599976Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeicon);
export default __webpack_public_path__ + "static/media/Theme icon.10f98061939c6a73bc83749679620d8b.svg";
export { ForwardRef as ReactComponent };